<template>
  <div v-if="!featureData.activeObj.id" class="modual-component" ref="modualComponent">
    <!-- Search -->
    <div class="mk-resource__search mb-2">
      <div class="input-group">
        <input v-model="searchInput" type="text" class="form-control text-start mk-resource__search__input" placeholder="搜尋模板">
        <img v-show="resetBtnShow" 
          :src="GetImageUrl('icons/x.svg')" 
          alt="" 
          class="mk-resource__search__reset-icon mk-resource__search__reset-icon--border"
          @click="cleanInput"
        >
      <button class="mk-btn mk-resource__search__button" @click="searchMaterials">
        <img :src="GetImageUrl('dropdowns/white_search.svg')" alt="">
      </button>
      </div>
    </div>
    <!-- MaterialCategories -->
    <div v-if="!atMaterialList" class="mk-resource__content">
      <div v-for="(materialCategory, index) in materialCategories" :key="index" class="mk-resource__item mk-resource__item--width">
        <div class="mk-resource__item-content" role="button" @click="selectMaterialCategory(materialCategory.name)">
          <!-- image -->
          <div class="mk-image-box">
            <img src="#" alt="沒有圖片" v-if="!materialCategory.img_url">
            <img :src="materialCategory.img_url" :alt="materialCategory.name" v-else>
          </div>
          <!-- info -->
          <div class="ps-2 pt-3">
            <div class="pb-3 mk-resource__item-title text-start">{{ materialCategory.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Materials -->
    <template v-else>
      <template v-if="materials.length == 0">
        <div class="search-title">
          <img :src="GetImageUrl('tools/back_icon.svg')" alt="goback" @click="backToMaterialCategories">
          <span>搜尋不到相關素材結果</span>
        </div>
        <div class="mk-resource__search-not-found alert alert-warning" role="alert">
          <div>
            <p> 抱歉！您搜尋的'{{searchTitle}}'沒有回傳任何素材模板</p>
            <p> 請使用其他關鍵字搜尋素材</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="search-title">
          <img :src="GetImageUrl('tools/back_icon.svg')" alt="goback" @click="backToMaterialCategories">
          <span>{{searchTitle}}</span>
        </div>
        <div class="mk-resource__content">
          <div v-for="(material,index) in materials" :key="index" class="mk-resource__item mk-resource__item--width">
            <div class="mk-resource__item-content" @click="createModule(material.id)">
              <!-- image -->
              <div class="mk-image-box">
                <img src="#" alt="沒有圖片" v-if="!material.img_url">
                <img :src="material.img_url" :alt="material.meta_id" v-else>
              </div>
              <!-- info -->
              <div class="ps-2 pt-3">
                <div class="pb-3 mk-resource__item-title text-start">{{material.meta_id}}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
  </div>
  <div v-else ref="modualColorComponent">
    <div v-if="featureData.panelTitle === '變更顏色'">
      <!-- desktop -->
      <div class="module-color-panel d-md-flex d-none">
        <div class="module-image-colors">
          <span>顏色：</span>
          <div v-for="(color, index) in imageColors" :key="index" class="color-box" :class="[activeClassName(index), isNotSupportColor(index) ? 'color-box--disabled' : '']" :style="`background-color: ${color.code};`" @click="selectImageColor(index)"></div>
        </div>
        <div class="module-selected-color">
          <div>已選顏色：</div>
          <div class="color-box" :style="`background-color: ${imageColors[selectedColorIndex].code};`"></div>
        </div>
        <div class="color-block">
          <div class="color-box" v-for="color in moduleColors" :key="color.name" :style="`background-color: ${color.code};`" @click="changeColor(color)"></div>
        </div>
      </div>
      <!-- mobile -->
      <div v-if="!featureData.moduleChildPanel" class="module-color-panel d-flex d-md-none">
        <div v-for="(color, index) in imageColors" :key="index" class="module-image-colors" @click="intoModuleChildPanel(index)">
          <div class="d-flex align-items-center">
            <div class="color-box" :class="[isNotSupportColor(index) ? 'color-box--disabled' : '']" :style="`background-color: ${color.code};`"></div>
            <div class="ms-2">{{ color.name }}</div>
          </div>
          <img v-if="!isNotSupportColor(index)" src="../../images/tools/goto_icon.png" alt="" width="15">
        </div> 
      </div>
      <div v-else class="module-color-panel d-flex d-md-none" >
        <div class="module-selected-color">
          <div>已選顏色：</div>
          <div class="color-box" :style="`background-color: ${imageColors[selectedColorIndex].code};`"></div>
        </div>
        <div class="color-block">
          <div class="color-box" v-for="color in moduleColors" :key="color.name" :style="`background-color: ${color.code};`" @click="changeColor(color)"></div>
        </div>
      </div>   
    </div>
    <div v-else>
      <div class="dl-panel-item" @click="updateTitle('變更顏色')" style="cursor: pointer;">
        <span>編輯</span>
        <div class="d-flex align-items-center" style="gap: 0.25rem">
          <div v-for="(color, index) in imageColors" :key="index" class="color-box" :style="`background-color: ${color.code};`"></div>
          <img src="../../images/tools/goto_icon.png" alt="" width="15">
        </div>
      </div>
      <div class="dl-panel-item">
        <span>常規定位</span>
        <div class="dl-panel-item__box dl-panel-item__box--hover dl-panel-item__box--right-margin" @click="handleAlignClick()">置中</div>
      </div>
      <div class="dl-panel-item">
        <span>規格</span>
        <div class="d-flex align-items-center gap-md-2 gap-1">
          <div class="d-flex align-items-center gap-2">
            寬度<input 
              class="dl-panel-item__box dl-panel-item__box--m-small" 
              inputmode="decimal"
              type="number" 
              step="0.1" 
              min="0" 
              v-model="featureData.activeObj.inputWidthCm"
              @focus="setFocusedInput"
              @blur="handleChangeSize('width', $event, true)"
              @keydown.enter="handleChangeSize('width', $event, false)"/>cm
          </div>
          <span style="font-size: 14px;">&ensp;x&ensp;</span>
          <div class="d-flex align-items-center gap-2">
            高度<input 
              class="dl-panel-item__box dl-panel-item__box--m-small" 
              inputmode="decimal"
              type="number" 
              step="0.1" 
              min="0" 
              v-model="featureData.activeObj.inputHeightCm"
              @focus="setFocusedInput"
              @blur="handleChangeSize('height', $event, true)"
              @keydown.enter="handleChangeSize('height', $event, false)"/>cm
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {GetImageUrl} from "@/javascripts/utils.js";
  import {computed, onMounted, ref, reactive, watch} from 'vue'
  import { useDesignLabStore } from "./DesignLabStore.js";
  import { featureData, setFeatureData, getModule, changeModuleColors, moduleColorLock, setScollTop, handleAlignClick, changeFabricImageSize, setFocusedInput, clearFocusedInput } from "~/vues/utils/feature.js"
  import axios from "axios";
  
  const store = useDesignLabStore();
  const modualComponent = ref(null);
  const modualColorComponent = ref(null);

  const materialCategories = ref([]);
  const searchTitle = ref('');
  const materials = ref([]);

  const searchInput = ref('');
  const resetBtnShow = computed(() => searchInput.value !== '')

  const atMaterialList = ref(false);

  const imageColors = ref([]);
  const moduleColors = computed(() => store.moduleColors);
  const selectedColorIndex = ref(0);

  watch(() => featureData.activeObj.id, (newV) => {
    selectedColorIndex.value = 0;
    if (newV && featureData.activeObj.design_type == 'svgImage') {
      imageColors.value = featureData.activeObj.imageColors ? JSON.parse(JSON.stringify(featureData.activeObj.imageColors)) : [];
    }
  }, {deep: true})

  const searchMaterials = async () => {
    if(searchInput.value === '') {
      atMaterialList.value = false;
      return;
    }

    const result = await store.getMaterials(null, searchInput.value);
    searchTitle.value = result.title;
    materials.value = result.materials;
    atMaterialList.value = true;
    setScollTop(modualComponent.value.parentElement);
  }

  const selectMaterialCategory = async (materialCategoryName) => {
    const result = await store.getMaterials(materialCategoryName, null);
    searchTitle.value = result.title;
    materials.value = result.materials;
    atMaterialList.value = true;
    setScollTop(modualComponent.value.parentElement);
  }

  const backToMaterialCategories = () => {
    searchInput.value = ''
    atMaterialList.value = false;
    setScollTop(modualComponent.value.parentElement);
  }

  const cleanInput = () => {
    searchInput.value = ''
  }

  const selectImageColor = (index) => {
    if(isNotSupportColor(index)) return;
    selectedColorIndex.value = index;
  }

  const isNotSupportColor = (index) => {
    if(imageColors.value[index].name === '') return true
  }

  const activeClassName = (index) => {
    return selectedColorIndex.value === index ? 'active' : ''
  }

  const createModule = (id) => {
    getModule(id)
  }

  const updateTitle = (title) => {
    setFeatureData('panelTitle', title)
    setScollTop(modualColorComponent.value.parentElement)
  }

  const intoModuleChildPanel = (index) => {
    if(isNotSupportColor(index)) return;
    setFeatureData('moduleChildPanel', true)
    selectedColorIndex.value = index;
    setScollTop(modualColorComponent.value.parentElement)
  } 

  const changeColor = (color) => {
    if(!moduleColorLock.value && imageColors.value[selectedColorIndex.value] != color) {
      moduleColorLock.value = true;
      imageColors.value[selectedColorIndex.value] = color
      changeModuleColors(featureData.activeObj.image_id, imageColors.value);
    }   
  }

  const handleChangeSize = (side, event, isClear = false) => {
    const value = (Math.floor(event.target.value * 10) / 10); // 這邊輸入的值無條件捨去到小數第一位
    if(isClear) clearFocusedInput(event);
    
    if(featureData.activeObj.design_type == 'svgImage') changeFabricImageSize(side, value);
  }

  onMounted(async () => {
    materialCategories.value = await store.getMaterialCategories();
    if (featureData.activeObj.design_type == 'svgImage') {
      imageColors.value = featureData.activeObj.imageColors ? JSON.parse(JSON.stringify(featureData.activeObj.imageColors)) : [];
    }
  })

</script>

<style lang="scss" scoped>
  .modual-component {
    padding: 0 1rem;
    // cover featureData.panelTitle
    .search-title{
      position: absolute;
      z-index: 9999;
      top: 0;
      left: 1rem;
      right: 1.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 5%;
      min-height: 30px;
      vertical-align: middle;
      text-align: center;
      font-size: large;
      font-weight: bolder;
      background: white;
      > img {
        position: absolute;
        width: 0.8rem;
        height: 0.8rem;
        // top: 10px;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }
    .mk-resource__search {
      max-width: 100%;
      &__input {
        box-shadow: none;
        outline: none;
        border-radius: 3rem;
        border: 1px solid #ced4da;
        border-right: none;
      }
      &__reset-icon {
        &--border {
          border: 1px solid #ced4da;
        }
      }
    }

    .mk-resource__item--width {
      width: 50%;
    }
  }
  
</style>